// @ts-nocheck
import { useState, useEffect } from "react";
import { useUserType } from "../../../../../hooks/useUserType";
import { XcaliberModelButton } from "../../../../../components/buttons/Buttons";
import cornerstone from "cornerstone-core";
import cornerstoneTools from "cornerstone-tools";
import { 
    XCALIBER_ANALYSIS_MODELS, 
    TOOL_IDS, 
    XCALIBER_NON_SLIDER_RESULT_TYPES,
    XCALIBER_NON_SLIDER_MODELS 
} from "../../consts/tools.consts";
import { useXcaliberAnalysis } from "pages/viewer/hooks/xcaliber/useXcaliberAnalysis";
import { toast } from "react-toastify"; 
import useSelectedXcaliberModels from "pages/viewer/hooks/xcaliber/useSelectedXcaliberModels";
import { addXcaliberPdfNotes, retrieveXcaliberPdf, submitXCaliberRequest, submitXcaliberFeedback } from "services/xCaliber";
import { useAppContext } from "context/app.context";
import { ToolSpinner } from "pages/viewer/components/dicom-viewer-toolbar/tool-button/ToolSpinner";
import { useViewerContext } from "pages/viewer/context/viewer.context";
import Tooltip from "@mui/material/Tooltip";

export const XcaliberFeedbackButton = (  {selectedModels, setSelectedModels}  ) => {
    const { userTypeColour } = useUserType();
    const [availableModels, setAvailableModels] = useState([]);
    const xcaliberAnalysis = useXcaliberAnalysis();
    const { state: { userId, xcaliberStatus } } = useAppContext();
    const [isSubmittingNotes, setIsSubmittingNotes] = useState(false);
    const { state: { xcaliberAnalysisStudy, activeToolIds, viewportFrameIndexes, viewportStatuses, studyImageMetaData, studyImageData, viewports } } = useViewerContext();
    const [showModal, setShowModal] = useState(false);
    const [inputValues, setInputValues] = useState(() => {
        // Initialize one entry per model
        const init = {};
        availableModels.forEach(m => init[m] = '');
        return init;
    });
    // Ensure initial state is set once models are available
    const [selectedModel, setSelectedModel] = useState(null);

    useEffect(() => {
        if (availableModels.length > 0) {
        setSelectedModel(availableModels[0]);
        setInputValues(() =>
            availableModels.reduce((acc, model) => {
            acc[model] = ''; // each gets its own empty string
            return acc;
            }, {})
        );
        }
    }, [availableModels]);

    const modalStyle = {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
    };

    useEffect(() => {
        if (
            xcaliberAnalysis.xcaliberAnalysis != null &&
            xcaliberAnalysis.xcaliberAnalysis?.data
        ) {
            const availableModels = XCALIBER_ANALYSIS_MODELS.filter(
                (key) => key in xcaliberAnalysis.xcaliberAnalysis.data
            );
            setAvailableModels(availableModels);
        }
    }, [xcaliberAnalysis]);

    const handleClickAgree = async () => {
        const studyImageIndex = viewports[0]?.studyImageIndex;
        const sopIuid = studyImageData[studyImageIndex]?.sopIuid;

        const feedback = {"all" : "agree"};

        await submitXcaliberFeedback(sopIuid, feedback);
        toast.success("Analysis approved")
    };
    
    const handleClickDisagree = async () => {
        setShowModal(true);
    };

    const handleSubmitFeedback = async () => {
        setIsSubmittingNotes(true);
        const studyImageIndex = viewports[0]?.studyImageIndex;
        const sopIuid = studyImageData[studyImageIndex]?.sopIuid;
        await submitXcaliberFeedback(sopIuid, inputValues);
        setIsSubmittingNotes(false);
        toast.success("Feedback Submitted");
    };
    
    const handleCancel = () => {
        setShowModal(false);
    };

    const handleInputChange = (e) => {
        setInputValues(prev => ({
          ...prev,
          [selectedModel]: e.target.value,
        }));
    };

    return (
        <div>
            {activeToolIds.includes(TOOL_IDS.XCALIBER_TOOL) && xcaliberAnalysis && xcaliberAnalysis.xcaliberAnalysis && xcaliberAnalysis.xcaliberAnalysis.data &&
            <div
                style={{
                    display: "flex",
                    margin: "0 8px",   // 4px buffer left/right
                    border: `2px solid ${userTypeColour}`,
                    borderRadius: "4px",
                    padding: "1px 2px",      // 4px top/bottom, 8px left/right inset
                    backgroundColor: "transparent",
                    alignItems: "center",
                    color: "white",
                    paddingLeft: "8px",
                }}
            >
                AI Feedback:
                <Tooltip title="Agree with the analysis">
                    <XcaliberModelButton
                        id='xcaliberAgreeButton'
                        key='xcaliberAgreeButton'
                        onClick={() => handleClickAgree()} //currently clicks automatically on initialisation
                        buttoncolor={ userTypeColour }
                        textcolor={ "white" }
                        display={ "none" }
                        sx={{ padding: "2px 6px", minWidth: "auto" }}
                    >
                    &#10003;
                    </XcaliberModelButton>
                </Tooltip>
                <Tooltip title="Disagree with the analysis">
                    <XcaliberModelButton
                        id='xcaliberDisagreeButton'
                        key='xcaliberDisagreeButton'
                        onClick={() => handleClickDisagree()} //currently clicks automatically on initialisation
                        buttoncolor={ userTypeColour }
                        textcolor={ "white" }
                        display={ "none" }
                        sx={{ padding: "2px 6px", minWidth: "auto" }}
                    >
                    x
                    </XcaliberModelButton>
                </Tooltip>
            </div>
            }

            {/* Modal for Text Entry */}
            {showModal && (
                <div style={modalStyle}>
                    <div style={{ backgroundColor: 'white', padding: 20, borderRadius: 8, width: '600px', maxWidth: '90%' }}>

                        {/* Top row with PDF button */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                            {/* Model selector buttons */}
                            <div style={{ display: 'flex', gap: '10px' }}>
                                {availableModels.map(model => (
                                    <button
                                    key={model}
                                    onClick={() => setSelectedModel(model)}
                                    style={{
                                        backgroundColor: selectedModel === model ? userTypeColour : '#eee',
                                        color: selectedModel === model ? 'white' : '#000',
                                        padding: '6px 10px',
                                        borderRadius: '6px',
                                        border: 'none',
                                        cursor: 'pointer',
                                    }}
                                    >
                                    {model.substring(model.lastIndexOf("_") + 1).toUpperCase()}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <p style={{ color: userTypeColour }}>
                            Please briefly explain why you disagree with the analysis for: <b>{selectedModel.substring(selectedModel.lastIndexOf("_") + 1).toUpperCase()}</b>
                        </p>

                        <textarea
                            value={inputValues[selectedModel] || ''}
                            onChange={handleInputChange}
                            rows={4}
                            style={{
                            marginBottom: 10,
                            padding: 8,
                            width: '100%',
                            resize: 'vertical',
                            borderRadius: '6px',
                            border: '1px solid #ccc',
                            }}
                        />

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', width: '100%' }}>
                            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '6px' }}>
                                {/*Submit-Notes button*/}
                                <button
                                onClick={handleSubmitFeedback}
                                style={{
                                    color: 'white',
                                    backgroundColor: userTypeColour,
                                    padding: '8px 14px',
                                    borderRadius: '6px',
                                    border: 'none',
                                    cursor: 'pointer'
                                }}
                                >
                                {isSubmittingNotes? <ToolSpinner /> : 'Submit'}
                                </button>

                                <span style={{ fontSize: '12px', color: userTypeColour }}>*For this image only</span>
                            </div>
                                
                            {/*Cancel button*/}
                            <button
                            onClick={handleCancel}
                            style={{
                                marginLeft: 10,
                                backgroundColor: '#ccc',
                                padding: '8px 14px',
                                borderRadius: '6px',
                                border: 'none',
                                cursor: 'pointer'
                            }}
                            >
                            Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};